import * as i0 from "@angular/core";
export class FeatureStore {
}
FeatureStore.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FeatureStore_Factory() { return new FeatureStore(); }, token: FeatureStore, providedIn: "root" });
